import { AppState } from 'src';
import { Dispatch, connect } from 'react-redux';
import { DateTimePickerComponentProperties, DateTimePickerComponent } from './date-time-picker.component';
import * as moment from 'moment-timezone';

interface DateTimePickerProperties {
  readonly dateValue?: Date;
  readonly saveCallback?: () => void;
  readonly changeCallback?: (date: Date) => void;
  readonly buttonRef?: (button: HTMLButtonElement) => void;
  readonly isLoading?: boolean;
  readonly requiresValue?: boolean;
  readonly formString: string;
  readonly modelString: string;
  readonly label: string;
  readonly maxDate?: Date;
  readonly minDate?: Date;
  readonly className?: string;
  readonly disabled?: boolean;
}

function mapStateToProps(
  state: AppState,
  ownProps: DateTimePickerProperties
): Partial<DateTimePickerComponentProperties> {
  return {
    dateValue: ownProps.dateValue,
    saveCallback: ownProps.saveCallback,
    changeCallback: ownProps.changeCallback,
    buttonRef: ownProps.buttonRef,
    isLoading: false,
    formString: ownProps.formString,
    modelString: ownProps.modelString,
    requiresValue: ownProps.requiresValue,
    maxDate: ownProps.maxDate ? moment(ownProps.maxDate) : undefined,
    minDate: ownProps.minDate ? moment(ownProps.minDate) : undefined,
    className: ownProps.className,
    disabled: ownProps.disabled
  };
}
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: DateTimePickerProperties
): Partial<DateTimePickerComponentProperties> {
  return {};
}

export const DateTimePicker = connect(
  mapStateToProps,
  mapDispatchToProps
)(DateTimePickerComponent);



// WEBPACK FOOTER //
// ./src/common/components/date-time-picker/date-time-picker.container.ts